const MASTER_LINKS_NAMES = ['Все ссылки', 'Распознанные ссылки']

export const isMasterLink = (name: string | undefined): boolean => {
    if (!name) {
        return false
    }
    return MASTER_LINKS_NAMES.includes(name)
}
